import React from 'react';

/**
 * Componente de spinner de carga
 * @param {Object} props - Props del componente
 * @param {string} [props.size='lg'] - Tamaño del spinner (sm, md, lg)
 * @param {string} [props.color='blue'] - Color del spinner
 * @param {string} [props.message] - Mensaje opcional
 * @returns {JSX.Element} Spinner de carga
 */
const LoadingSpinner = ({
  size = 'lg',
  color = 'blue',
  message = 'Cargando...'
}) => {
  const sizeClasses = {
    sm: 'h-16 w-16',
    md: 'h-24 w-24',
    lg: 'h-32 w-32'
  };

  const colorClasses = {
    blue: 'border-blue-600',
    gray: 'border-gray-600',
    green: 'border-green-600'
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className={`animate-spin rounded-full ${sizeClasses[size]} border-b-2 ${colorClasses[color]} mx-auto`}></div>
        {message && (
          <p className="mt-4 text-gray-600 text-lg">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;